import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class InvalidPaymentInformationsError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidPaymentInformationsError";
    }
}
export class InvalidSubscriptionError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidSubscriptionError";
    }
}
export class NoPaymentRequiredError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NoPaymentRequiredError";
    }
}
export class ForbiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ForbiddenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    UnauthorizedError,
    InvalidPaymentInformationsError,
    InvalidSubscriptionError,
    NoPaymentRequiredError,
    ForbiddenError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
